
export const state = {
    facility_view: 'none',
    //audits:[],
    
};

export const mutations = {
    setView(state, payload){
        state.facility_view = payload;
    },

    //eslint-disable-next-line
    clearAll(state, payload){
        state.facility_view = 'none';
    },
};

export const actions = {
    setFacilityView({commit}, type){
        return new Promise((resolve)=>{
            commit('setView', type);
            resolve();
        })
    },
    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },
};



